import React, {Component} from 'react'
import { connect } from 'react-redux';

import {
    CONNECTION_STATE_INITIAL,
    CONNECTION_STATE_CONNECTING,
    CONNECTION_STATE_CONNECTED,
    CONNECTION_STATE_STALLED,
    CONNECTION_STATE_DISCONNECTED_BY_SERVER,
    CONNECTION_STATE_RECONNECTING
} from '../../../constants/connectionState';


import './styles.scss'

class RestartIndicator extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    	if (!this.props.restart.restart) {
    		if (this.state.intervalHandler) {
    			clearInterval(this.state.intervalHandler);
    			this.setState({intervalHandler: null});
    		}
    	}

    	if (this.props.restart.restart && !this.state.intervalHandler) {
    		let that = this;
			let handler = setInterval(function() {
				console.log("restart tick");
				let now = Math.floor(new Date().getTime() / 1000);
				that.setState({now: now});
	        	//this.props.dispatch({type: "restart_tick"});
	        }, 10000);
	        this.setState({intervalHandler: handler});
		}
    }

    render() {
    	if (!this.props.restart.restart) {
    		return null;
    	}
    	let restart = this.props.restart.restart;
    	let now = this.state.now;
    	if (!now) now = Math.floor(new Date().getTime() / 1000);
    	let minutesLeft = Math.round((restart.scheduledTimestamp - now) / 60 );

    	if (this.props.connectionState !== CONNECTION_STATE_CONNECTED) {
    		return (<div className="restartIndicator">BobTV restarting</div>);
    	}

    	if (minutesLeft < 0) {
    		return null;
    	} else if (minutesLeft == 1) {
    		return (<div className="restartIndicator">BobTV will restart in 1 minute</div>);
    	} else if (minutesLeft == 0) {
    		return (<div className="restartIndicator">BobTV is just about to restart</div>);
    	} else {
    		return (<div className="restartIndicator">BobTV will restart in {minutesLeft} minutes</div>);
    	}
       
    }
}

function mapStateToProps(state) {
    return {
    	connectionState: state.connectionState,
        restart: state.restart
    };
}


export default connect(mapStateToProps)(RestartIndicator);




// WEBPACK FOOTER //
// ./src/components/bobtv-neo/RestartIndicator/index.js